import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileText, Loader2 } from "lucide-react";
import { EmptyState, ScreenHeader } from "@/components/AppUI";
import { papi } from "@/lib/pizzeria";

export default function LegalPage() {
  const { doc } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setData(null);
    papi.get(`/legal/${doc}`).then(({ data: d }) => setData(d)).catch(() => setError(true));
  }, [doc]);

  return (
    <div className="flex-1" data-testid="legal-page">
      <ScreenHeader title={data?.title || (doc === "privacy" ? "Privacy" : "Termini")} fallback="/profilo" />
      {error ? <EmptyState icon={FileText} title="Documento non disponibile" /> : !data ? <Loader2 className="h-6 w-6 animate-spin mx-auto mt-12" style={{ color: "var(--brand)" }} /> : (
        <div className="p-4 pb-10 space-y-5">
          {data.updated && <p className="text-xs" style={{ color: "var(--muted-c)" }}>Aggiornato il {data.updated}</p>}
          {(data.sections || []).map((s, i) => (
            <div key={i} className="space-y-1.5" data-testid={`legal-section-${i}`}>
              <p className="text-base font-medium">{s.title}</p>
              <p className="text-sm leading-6 whitespace-pre-line" style={{ color: "var(--muted-c)" }}>{s.body}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
